
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-adyar",
      function () {
        return require("private-next-pages/tnpsc-adyar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-adyar"])
      });
    }
  